<template>
  <!-- 菜单管理 -->
  <div class="wrapper">
    <div class="btn-group">
      <div></div>
      <div>
        <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)"
            type="primary"
            size="mini"
            @click="goAddRootMenu"
        >新增</el-button
        >
      </div>
    </div>

    <el-table
        :data="list"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :header-row-style="{ height: '50px', color: '#626e7c' }"
        :cell-style="changeTr"
        :header-cell-style="changeHeader"
    >
      <el-table-column label="名称" align="left" width="300px">
        <template slot-scope="scope">
          {{ scope.row.menuName }}
        </template>
      </el-table-column>
      <el-table-column label="菜单类型" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.menuType == 1" type="success">目录</el-tag>
          <el-tag v-if="scope.row.menuType == 2" type="info">菜单</el-tag>
          <el-tag v-if="scope.row.menuType == 3" type="warning">按钮</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)" :underline="false" type="primary" @click="goAdd(scope.row)">新增</el-link>
          <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_edit)" :underline="false" style="margin:0 10px" type="primary" @click="goEdit(scope.row)">编辑</el-link>
          <el-link
              v-checkbtn="isShowBtn(AUTH_BTN.menu_list_del)"
              @click="apiDelMenu(scope.row.id)"
              :underline="false"
              style="margin-left:10px"
              type="danger"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 保存菜单 -->
    <el-dialog :title="formTitle" :visible.sync="dialogVisible" width="600px" :show-close="false">
      <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
        <el-form-item label="上级菜单">
          <MenuTreeSelect ref="menuRef" v-model="formData.parentId" />
        </el-form-item>
        <el-form-item label="名称" prop="menuName">
          <el-input style="width:400px" v-model="formData.menuName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menuType">
          <el-select style="width:400px" v-model="formData.menuType" clearable placeholder="请选择">
            <el-option v-for="item in MENU_TYPE" :key="item.value" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="路由标识" prop="routeCode">
          <el-input style="width:400px" v-model="formData.routeCode" placeholder="路由标识"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input style="width:400px" v-model="formData.sort" placeholder="排序"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="" @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getMenusTree, delMenu, getMenuDetail, editMenu, addMenu } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import MenuTreeSelect from "./menu-tree-select.vue";
import { MENU_TYPE } from "@/enum/dict";

export default {
  name: 'SystemMenuList',
  components: {MenuTreeSelect},
  mixins: [authBtnMixin],
  data() {
    return {
      list: [],
      total: 0,
      dialogVisible: false,
      formTitle: '新增菜单',
      formData: {
        parentId: 0,
        menuName: '', //菜单名称
        menuType: '', //菜单类型
        routeCode: '', //路由标识
        // permCode: '', //权限标识
        sort: 1,
      },
      rules: {
        menuName: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '菜单类型不能为空', trigger: 'blur' }
        ],
        routeCode: [
          { required: true, message: '路由标识不能为空', trigger: 'blur' }
        ]
      },
      MENU_TYPE, //菜单类型
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.apiQueryMenuTree();
  },
  methods: {
    async apiQueryMenuTree() {
      let res = await getMenusTree();
      this.list = res || [];
    },
    initFormData() {
      this.formData = {
        parentId: 0,
        menuName: '',
        menuType: '',
        routeCode: '',
        // permCode: '',
        sort: 1,
      };
    },
    // 新增一级菜单
    goAddRootMenu() {
      this.initFormData();
      this.dialogVisible = true;
    },
    // 新增子菜单
    goAdd(row) {
      const { id } = row;
      this.initFormData();
      this.formData.parentId = id;
      this.$nextTick(() => {
        this.$refs.menuRef.getMenusTree();
      });
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    async save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // formData中有menuId情况为编辑，无则为新增
          if (this.formData.id) {
            await editMenu(this.formData).then(() => {
              this.apiQueryMenuTree();
              this.$message.success('编辑成功');
              this.dialogVisible = false;
            })
          } else {
            if (this.formData.parentId > 0) {
              await addMenu(this.formData).then(() => {
                this.apiQueryMenuTree();
                this.$message.success('新增成功');
                this.dialogVisible = false;
              })
            } else {
              await addMenu(this.formData).then(() => {
                this.apiQueryMenuTree();
                this.$message.success('新增成功');
                this.dialogVisible = false;
              })
            }
          }
        } else {
          return false;
        }
      })
    },
    async apiQueryMenuDetail(id) {
      this.formData = await getMenuDetail({ id });
    },
    goEdit(row) {
      const { id } = row;
      this.formTitle = '编辑菜单';
      this.apiQueryMenuDetail(id);
      this.dialogVisible = true;
    },
    async apiDelMenu(id) {
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delMenu(id).then(() => {
              this.apiQueryMenuTree();
              this.$message({ type: 'success', message: '操作成功!' });
            })
          })
          .catch(() => {})
    },
    // 修改第一列无children的样式
    changeTr({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '100px' };
      }
      if (columnIndex == 0) {
        return { paddingLeft: '100px' };
      }
    },
    changeHeader({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return { background: '#f8f9fb', padding: '8px 0 0 130px' };
      } else {
        return { background: '#f8f9fb', padding: '8px 0' };
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  /deep/.one-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
